import { Component, EventEmitter, Inject, Input, OnInit, OnChanges, SimpleChanges, Output } from "ng-metadata/core";
import { beacon, PrimolyticsService } from "../../../analytics/primolytics.service";
import { getResultsBulkSize, getVENumberOfResultsPerPageSeries, getVid } from "../../../appConfig/appConfigForward";
import { StorageUtil } from "../../../infra/storageUtil.service";
import { ConfigurationUtil } from "../../../nddUtils/configurationUtil.service";
import { ResultUtil } from "../../../nddUtils/resultUtil.service";
import { StringUtils } from "../../../nddUtils/stringUtils.service";
import { JwtUtilService } from "../../../security/jwtUtil.service";
import { PageNavMenuService } from "../searchResultList/pageNavMenu/pageNavMenu.service";
import { MediaQueries } from "../../../infra/mediaQueries.service";

@Component({
    "selector": "prm-search-result-page-range",
    templateUrl: 'components/search/searchResult/searchResultPageRange/search-result-page-range.html'
})

export class PrmSearchResultPageRange implements OnInit, OnChanges {

    @Input() private currentPageNum: number;
    @Input() private totalResults: number;
    @Input() private totalResultVersion: number;
    @Input() private showPartialResultsWarning: boolean;
    @Input() private uiType: string;
    @Input() private isCategoriesSearch: boolean;
    @Output() private changeRangeEvent = new EventEmitter();
    private numberOfResultsPerPageList: number[];

    constructor(private configurationUtil: ConfigurationUtil,
        private storageUtil: StorageUtil,
        private jwtUtilService: JwtUtilService,
        private pageNavMenuService: PageNavMenuService,
        private resultUtil: ResultUtil,
        private stringUtils: StringUtils,
        private mediaQueries: MediaQueries,
        private primolyticsService: PrimolyticsService,
        @Inject('$state') public $state: ng.ui.IStateService,
        @Inject('$translate') private $translate: ng.translate.ITranslateService) {
        this.pageNavMenuService.getResultNumberRange();
    }

    ngOnInit() {
        if (this.resultUtil && this.resultUtil.updatedBulkSize) {
            this.PAGE_SIZE = this.resultUtil.updatedBulkSize;
        }
        else {
            this.PAGE_SIZE = getResultsBulkSize(this.$state.current.name);
        }
        this.numberOfResultsPerPageList = this.numberOfResultsPerPageSeries();
        this.pageNavMenuService.isCategoriesSearchVal = this.isCategoriesSearch;
        this.updatePageNavMenu();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.totalResults || changes.currentPageNum) {
            this.updatePageNavMenu();
        }
    }

    private updatePageNavMenu() {
        this.pageNavMenuService.currentPageNumVal = this.currentPageNum;
        this.pageNavMenuService.totalResultsVal = this.totalResults;
        this.pageNavMenuService.isCategoriesSearchVal = this.isCategoriesSearch;
        this.pageNavMenuService.getResultNumberRange();
        this.pageNavMenuService.initPageList();
        this.pageNavMenuService.updateRangeTitle();
    }

    get rangeTitle() {
        return this.pageNavMenuService.rangeTitle;
    }

    set rangeTitle(rangeTitle) {
        this.pageNavMenuService.rangeTitle = rangeTitle;
    }

    get PAGE_SIZE(): number {
        return this.pageNavMenuService.PAGE_SIZE;
    }

    set PAGE_SIZE(PAGE_SIZE: number) {
        this.pageNavMenuService.PAGE_SIZE = PAGE_SIZE;
    }

    get totalResultsNum() {
        return this.totalResults;
    }

    set totalResultsNum(total) {
        this.totalResults = total;
    }

    public numberOfResultsPerPageSeries(): number[] {
        if (this.configurationUtil.isSuprima()) {
            return getVENumberOfResultsPerPageSeries();
        }
        return [10, 25, 50];
    }

    public updateSelectedText() {
        return this.pageNavMenuService.updateSelectedText();
    }


    private createRangeEvent() {
        let eventData = {
            bulkSize: this.PAGE_SIZE,
        }
        return eventData;
    }

    private onClick() {
        this.runChangeRangeSizeBeacon();
        this.pageNavMenuService.currentPageNumVal = 1;
        let eventData = this.createRangeEvent();
        this.pageNavMenuService.saveNumOfPageToLocalForage(this.PAGE_SIZE);
        this.pageNavMenuService.getResultNumberRange();
        let isSignedIn = this.jwtUtilService.isSignedIn();
        isSignedIn ? this.pageNavMenuService.updateBulkSizePerPageInDB(this.PAGE_SIZE) : true;
        this.resultUtil.setRangeData(this.PAGE_SIZE);
        this.changeRangeEvent.emit(eventData);
        this.pageNavMenuService.updateRangeTitle();
    }

    @beacon({ 'p': 'brief', 'op': 'numOfResults' })
    public runChangeRangeSizeBeacon() {
    }

    private translateLabel(label) {
        return this.$translate.instant(label);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultPageRange/searchResultPageRange.directive.ts